import EventitemScreen from './containers/eventitemScreen'

export {default as EventitemScreenLayout} from './components/eventitemScreenLayout'

export default EventitemScreen
